import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useApp } from '../../contexts/AppContext'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { AuthInfo } from '../../types/contexts/AuthContext'
import { RegisterDetails } from '../../types/user/auth'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'
import { rememberConfirmationEmailSent } from '../../utils/profile/confirmationEmail'

export function useRegister() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { poster } = useFetch()
  const { saveAuthInfo } = useAuth()
  const { lang, theme } = useApp()

  const register = async (registerDetails: RegisterDetails) => {
    setLoading(true)
    setError(null)
    try {
      const data = await poster<AuthInfo>(
        `${CONFIG.BOUNCE_API}/api/v1/account/register`,
        { ...registerDetails, language: lang, theme: theme.toUpperCase() },
        'application/json'
      )
      if (data) {
        // Registration sends the first confirmation email; resending waits out the cooldown from now.
        rememberConfirmationEmailSent(registerDetails.email)
        saveAuthInfo(data)
        return data
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { register, loading, error }
}
